export const ROUTER_OUTLET_NAME = "modal";
